export const us = [
    {
        id: "content-us-world-news",
        name: "World News",
        articles: [
            {
                id: "31b24534-29f6-469f-8ce3-ff774997ef8a",
                class: "columns-3-wide",
                header: "Happening Today",
                url: "#",
                image: {
                    src: "assets/images/todd-trapani-vS54KomBEJU-unsplash_684.jpg",
                    alt: "Placeholder",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "Photo taken by someone.",
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
                title: "Sed egestas egestas fringilla phasellus faucibus scelerisque eleifend.",
                type: "text",
                content:
                    "Iaculis urna id volutpat lacus. Dictumst vestibulum rhoncus est pellentesque elit ullamcorper. Dictum varius duis at consectetur lorem donec. At tellus at urna condimentum mattis pellentesque id. Consectetur lorem donec massa sapien faucibus et molestie ac. Risus at ultrices mi tempus.",
            },
            {
                id: "06f7b876-6120-4273-8850-f60f817940f0",
                class: "columns-3-narrow",
                header: "Trending",
                url: "#",
                image: {
                    src: "assets/images/mufid-majnun-tJJIGh703I4-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Ut eu sem integer vitae justo eget magna.",
                type: "text",
                content:
                    "Id neque aliquam vestibulum morbi blandit cursus risus at ultrices. Arcu dui vivamus arcu felis bibendum ut tristique et. Justo donec enim diam vulputate ut.\n\nPellentesque elit ullamcorper dignissim cras tincidunt lobortis feugiat vivamus at. Ipsum suspendisse ultrices gravida dictum fusce ut placerat. Convallis tellus id interdum velit laoreet id.",
            },
            {
                id: "e9f3877f-a2a6-41fb-898b-9acb0fdedc19",
                class: "columns-3-narrow",
                header: "Weather",
                url: "#",
                image: {
                    src: "assets/images/noaa--urO88VoCRE-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Id consectetur purus ut faucibus pulvinar elementum integer enim.",
                type: "list",
                content: [
                    {
                        id: "2ed5ca3f-6fca-4061-b055-d79058547e93",
                        content: "Pellentesque habitant morbi tristique senectus et. Vel eros donec ac odio tempor orci dapibus ultrices in.",
                    },
                    {
                        id: "afcab89c-38d8-4d5e-9b52-cd560cb92d96",
                        content: "Et odio pellentesque diam volutpat commodo sed egestas egestas fringilla.",
                    },
                    {
                        id: "e9c96309-74a2-4ceb-b0de-8b1a6be4fbdc",
                        content: "Et netus et malesuada fames ac turpis egestas. Maecenas ultricies mi eget mauris pharetra et ultrices.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-around-the-nation",
        name: "Around the Nation",
        articles: [
            {
                id: "4e19c383-aff6-45de-b874-008c58a9667f",
                class: "columns-3-balanced",
                header: "Latest",
                image: {
                    src: "assets/images/fons-heijnsbroek-vBfEZdpEr-E-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nullam eget felis eget nunc lobortis mattis aliquam.",
                type: "list",
                content: [
                    {
                        id: "f3197d93-1041-423d-b648-f7b717f7ea9d",
                        content: "Nibh ipsum consequat nisl vel. Senectus et netus et malesuada fames.",
                    },
                    {
                        id: "aa2cfed6-54e2-468d-9a03-dd4db4cab1b4",
                        content: "Lectus vestibulum mattis ullamcorper velit sed ullamcorper morbi.",
                    },
                    {
                        id: "37a7a6b1-710f-45da-a481-2a23c0d90a31",
                        content: "Blandit volutpat maecenas volutpat blandit aliquam etiam erat.",
                    },
                    {
                        id: "48103727-1181-4b8c-b536-062e8a868106",
                        content: "Non curabitur gravida arcu ac. Est sit amet facilisis magna etiam tempor orci eu lobortis.",
                    },
                ],
            },
            {
                id: "53c3567d-6073-41e8-87ca-f76a282c38f9",
                class: "columns-3-balanced",
                header: "Business",
                image: {
                    src: "assets/images/bram-naus-oqnVnI5ixHg-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Vestibulum rhoncus est pellentesque elit. Enim lobortis scelerisque fermentum dui faucibus.",
                type: "list",
                content: [
                    {
                        id: "2f03cb48-b182-46e7-a651-3bd04ee622bb",
                        content: "Sapien pellentesque habitant morbi tristique senectus et.",
                    },
                    {
                        id: "4cf064fc-6ad2-4ef4-9bca-ac6607da0912",
                        content: "Aliquet eget sit amet tellus cras adipiscing.",
                    },
                    {
                        id: "5fad11d7-ba53-487f-af21-e86b68a98d21",
                        content: "Tellus mauris a diam maecenas sed enim ut sem viverra.",
                    },
                ],
            },
            {
                id: "79344d21-3a1f-4531-87b7-971d0a01e959",
                class: "columns-3-balanced",
                header: "Politics",
                image: {
                    src: "assets/images/hansjorg-keller-CQqyv5uldW4-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Hendrerit dolor magna eget est. Nec dui nunc mattis enim ut tellus elementum sagittis.",
                type: "list",
                content: [
                    {
                        id: "68ad5e3b-68ae-41da-ab0d-a073c78a4ca7",
                        content: "Euismod elementum nisi quis eleifend quam adipiscing vitae proin sagittis.",
                    },
                    {
                        id: "c48f6f5f-6be3-41ec-a067-c1dc072c0beb",
                        content: "Ac tincidunt vitae semper quis lectus nulla at volutpat diam.",
                    },
                    {
                        id: "1917cf48-ce4b-4e80-8828-3b104fbacff7",
                        content: "In mollis nunc sed id semper risus in hendrerit. Turpis massa sed elementum tempus egestas sed sed risus. Imperdiet proin fermentum leo vel orci.",
                    },
                    {
                        id: "13fb8e39-13c9-4f97-a15f-95bde9351960",
                        content: "Nisl purus in mollis nunc sed id semper. Pretium lectus quam id leo in vitae.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-roundup",
        name: "Roundup",
        articles: [
            {
                id: "660d5f2a-0977-423b-a585-dbd0f58695e4",
                class: "columns-wrap",
                header: "Washington",
                type: "excerpt",
                content: [
                    {
                        id: "bd34fb90-27ff-4e57-b29b-1cec6c56b423",
                        image: {
                            src: "assets/images/unseen-histories-4kYkKW8v8rY-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nisl nisi scelerisque eu ultrices vitae. Consectetur adipiscing elit duis tristique sollicitudin. Ornare suspendisse sed nisi lacus. Justo eget magna fermentum iaculis.",
                    },
                    {
                        id: "30a4e957-4170-4613-8d9a-5b417b999568",
                        image: {
                            src: "assets/images/ian-hutchinson-P8rgDtEFn7s-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Tellus integer feugiat scelerisque varius morbi enim. Ut tristique et egestas quis.",
                    },
                    {
                        id: "ffc520db-68a5-451e-89df-86be7e126c10",
                        image: {
                            src: "assets/images/koshu-kunii-ADLj1cyFfV8-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nulla malesuada pellentesque elit eget gravida cum sociis natoque penatibus.",
                    },
                ],
            },
            {
                id: "c88e0e0d-e323-4d4e-a0fb-b72c3fda9df8",
                class: "columns-wrap",
                header: "East Coast",
                type: "excerpt",
                content: [
                    {
                        id: "f93e2af2-f8ff-4706-8290-11a2cec073eb",
                        image: {
                            src: "assets/images/matthew-landers-v8UgmRa6UDg-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Pharetra et ultrices neque ornare aenean euismod elementum nisi. Ipsum dolor sit amet consectetur adipiscing elit ut.",
                    },
                    {
                        id: "1298a3c4-6638-4afd-a34c-56ab2eaf281d",
                        image: {
                            src: "assets/images/c-j-1GHqOftzYo0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Quam vulputate dignissim suspendisse in est. Vestibulum mattis ullamcorper velit sed.",
                    },
                    {
                        id: "5e765702-4e99-4cc5-b958-aad34be0b826",
                        image: {
                            src: "assets/images/jacob-licht-8nA_iHrxHIo-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Habitant morbi tristique senectus et netus et. Ullamcorper sit amet risus nullam eget felis.",
                    },
                ],
            },
            {
                id: "a2267128-dd86-4a98-8903-0a887d49104e",
                class: "columns-wrap",
                header: "West Coast",
                type: "excerpt",
                content: [
                    {
                        id: "9c59f003-1eb3-4a86-9a00-9012470c2549",
                        image: {
                            src: "assets/images/maria-lysenko-tZvkSuBleso-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Bibendum enim facilisis gravida neque convallis a cras. Semper feugiat nibh sed pulvinar proin gravida hendrerit.",
                    },
                    {
                        id: "951ecd15-5add-4f8a-8eaf-053be96c923b",
                        image: {
                            src: "assets/images/peter-thomas-17EJD0QdKFI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Vel facilisis volutpat est velit. Odio ut sem nulla pharetra diam sit amet nisl.",
                    },
                    {
                        id: "450f1f73-9d36-497a-bab0-6ca7c28c4f68",
                        image: {
                            src: "assets/images/xan-griffin-QxNkzEjB180-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Risus nec feugiat in fermentum posuere urna nec. Massa tincidunt nunc pulvinar sapien.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-crime+justice",
        name: "Crime & Justice",
        articles: [
            {
                id: "bc92acd8-0cbb-42e6-88dc-7589e92eb218",
                class: "columns-3-balanced",
                header: "Supreme Court",
                type: "articles-list",
                content: [
                    {
                        id: "a795ce54-f3f2-4a32-b59d-2a88530638dd",
                        title: "Vel risus commodo viverra maecenas.",
                        content:
                            "Vitae tempus quam pellentesque nec nam aliquam sem. Mi in nulla posuere sollicitudin aliquam ultrices sagittis. Leo integer malesuada nunc vel. Ultricies integer quis auctor elit sed vulputate. Sit amet justo donec enim diam vulputate. Velit aliquet sagittis id consectetur purus ut faucibus pulvinar.",
                    },
                    {
                        id: "7add8464-9b82-428a-a8ec-6489b6c4f830",
                        title: "Sit amet mattis vulputate enim.",
                        content:
                            "Urna porttitor rhoncus dolor purus non. Tristique senectus et netus et malesuada fames ac turpis egestas. Suscipit tellus mauris a diam maecenas. Risus ultricies tristique nulla aliquet enim. Quis imperdiet massa tincidunt nunc pulvinar sapien et ligula ullamcorper.",
                    },
                    {
                        id: "45aa7276-1a3a-4be7-bd1c-c4885dd7e9e0",
                        title: "Mauris in aliquam sem fringilla ut morbi tincidunt.",
                        content:
                            "A erat nam at lectus. Orci sagittis eu volutpat odio facilisis mauris sit. Faucibus nisl tincidunt eget nullam non. Nisl condimentum id venenatis a. Suscipit tellus mauris a diam maecenas sed enim. Orci nulla pellentesque dignissim enim sit amet venenatis. Est ultricies integer quis auctor.",
                    },
                ],
            },
            {
                id: "190711e5-6bc8-4b26-920a-b6edd74a0847",
                class: "columns-3-balanced",
                header: "Local Law",
                type: "articles-list",
                content: [
                    {
                        id: "a126bcfa-9915-4cd4-8a7f-db36ba5e426e",
                        title: "Sit amet justo donec enim diam vulputate ut.",
                        content:
                            "Tincidunt dui ut ornare lectus sit amet est. Risus sed vulputate odio ut enim blandit volutpat maecenas volutpat. Posuere urna nec tincidunt praesent semper feugiat nibh sed pulvinar. Euismod in pellentesque massa placerat duis.",
                    },
                    {
                        id: "de6f2266-ab8b-4312-b11c-78258500035b",
                        title: "Aliquam ultrices sagittis orci a scelerisque purus semper eget duis.",
                        content:
                            "Lobortis feugiat vivamus at augue eget arcu. Id ornare arcu odio ut sem nulla pharetra diam. Mauris in aliquam sem fringilla ut morbi tincidunt augue interdum. Congue quisque egestas diam in arcu cursus euismod quis viverra.",
                    },
                    {
                        id: "2bac47f6-54c2-4c57-87cc-3a3f202ab290",
                        title: "In metus vulputate eu scelerisque felis imperdiet proin.",
                        content: "Elementum pulvinar etiam non quam. Id nibh tortor id aliquet lectus proin nibh. Elementum facilisis leo vel fringilla est ullamcorper eget. Dictum sit amet justo donec enim diam vulputate.",
                    },
                ],
            },
            {
                id: "0233b0b6-69f1-4c51-81cd-b849e435f2c1",
                class: "columns-3-balanced",
                header: "Opinion",
                type: "articles-list",
                content: [
                    {
                        id: "ad0f3eb3-42eb-43f5-bd8d-9a3b62ec5433",
                        title: "Magna ac placerat vestibulum lectus.",
                        content:
                            "enenatis urna cursus eget nunc scelerisque viverra mauris. Convallis posuere morbi leo urna molestie at elementum. Eu lobortis elementum nibh tellus. Vitae purus faucibus ornare suspendisse sed nisi lacus sed viverra.",
                    },
                    {
                        id: "b49fe19d-4bcc-42bb-9b85-8348cc64d4ca",
                        title: "Nisl rhoncus mattis rhoncus urna neque viverra justo.",
                        content:
                            "Tristique sollicitudin nibh sit amet. Aliquam purus sit amet luctus venenatis. Vitae nunc sed velit dignissim sodales ut. Elit scelerisque mauris pellentesque pulvinar pellentesque habitant morbi tristique senectus. Sit amet risus nullam eget.",
                    },
                    {
                        id: "65ca4cde-546a-496a-b731-71140adfb651",
                        title: "Sed felis eget velit aliquet sagittis id consectetur purus ut.",
                        content:
                            "Egestas erat imperdiet sed euismod nisi porta. Vel orci porta non pulvinar neque laoreet. Urna condimentum mattis pellentesque id nibh. Arcu non sodales neque sodales ut etiam sit amet. Elementum curabitur vitae nunc sed velit dignissim.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-around-the-us",
        name: "Around the US",
        articles: [
            {
                id: "90e08554-f9b4-4606-8e36-55de40b39f9f",
                class: "columns-3-balanced",
                header: "Latest",
                image: {
                    src: "assets/images/chloe-taranto-x2zyAOmVNtM-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Ut tortor pretium viverra suspendisse potenti nullam ac tortor.",
                type: "list",
                content: [
                    {
                        id: "572e5a00-1754-4fcd-bf5b-b13d781bea45",
                        content: "Erat pellentesque adipiscing commodo elit at. Ornare lectus sit amet est placerat in.",
                    },
                    {
                        id: "8b1304be-2622-432e-944c-341a9e4fd69d",
                        content: "Dui ut ornare lectus sit amet est placerat in egestas. Commodo sed egestas egestas fringilla phasellus.",
                    },
                    {
                        id: "d70f1cd5-2f57-4f85-b967-f15ac4c942cc",
                        content: "Mi quis hendrerit dolor magna eget est lorem ipsum. Urna molestie at elementum eu facilisis sed odio morbi.",
                    },
                    {
                        id: "d9482395-2aef-4e39-9a5c-8d64c4b31b03",
                        content: "Mauris rhoncus aenean vel elit scelerisque mauris pellentesque pulvinar.",
                    },
                ],
            },
            {
                id: "9c6014cf-a577-4611-a2ce-97f2b4afc322",
                class: "columns-3-balanced",
                header: "Business",
                image: {
                    src: "assets/images/razvan-chisu-Ua-agENjmI4-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nam at lectus urna duis convallis convallis tellus id. Sem nulla pharetra diam sit amet nisl.",
                type: "list",
                content: [
                    {
                        id: "815c097a-ae5e-417e-824f-5dc3f370cd4f",
                        content: "Nunc faucibus a pellentesque sit amet. Id velit ut tortor pretium viverra suspendisse potenti nullam ac.",
                    },
                    {
                        id: "a3b76c87-a288-400e-aeba-c89e97fb82a4",
                        content: "Eget mi proin sed libero enim sed. A scelerisque purus semper eget duis at tellus.",
                    },
                    {
                        id: "2a4b261c-f04f-4a4f-9d66-5e2d3eca79a3",
                        content: "Praesent tristique magna sit amet purus. Eros in cursus turpis massa.",
                    },
                ],
            },
            {
                id: "48cabfe4-6408-488f-b942-8d59d35163f7",
                class: "columns-3-balanced",
                header: "Politics",
                image: {
                    src: "assets/images/colin-lloyd-2ULmNrj44QY-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Tristique nulla aliquet enim tortor at auctor urna nunc.",
                type: "list",
                content: [
                    {
                        id: "7e69389e-794f-4e8b-9dc6-824214437fe6",
                        content: "Tincidunt ornare massa eget egestas purus viverra accumsan in nisl. Amet mattis vulputate enim nulla.",
                    },
                    {
                        id: "c72d48b6-a53c-4a86-ac7b-c720d5a63630",
                        content: "Pellentesque massa placerat duis ultricies. Tortor at auctor urna nunc id cursus.",
                    },
                    {
                        id: "4fa57fa6-0d49-4c2a-bc0e-fd9b3e21f1bf",
                        content: "Venenatis urna cursus eget nunc scelerisque viverra mauris.",
                    },
                    {
                        id: "7c33aa39-8819-49e8-abd0-53a3dbf8464b",
                        content: "Dolor morbi non arcu risus quis varius quam quisque id.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-latest-media",
        name: "Latest Media",
        articles: [
            {
                id: "92371ddb-b2cf-43e2-8590-bda1440c7025",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "f40d1399-24e7-4dcd-bcd1-663540bd5eae",
                        image: {
                            src: "assets/images/dominic-hampton-_8aRumOixtI-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "15a36d2e-797d-4b0f-8321-c439763fe201",
                        image: {
                            src: "assets/images/sam-mcghee-4siwRamtFAk-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "c46ee0db-4d30-46fc-8a52-c1007bf21cbf",
                        image: {
                            src: "assets/images/adam-whitlock-I9j8Rk-JYFM-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "c3d34280-d796-4039-9d5c-626b09e9b2d9",
                        image: {
                            src: "assets/images/leah-hetteberg-kTVN2l0ZUv8-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-business",
        name: "Business",
        articles: [
            {
                id: "8e2a8c79-f1dc-4e6c-8542-04684ae08bce",
                class: "columns-3-balanced",
                header: "Local",
                type: "articles-list",
                content: [
                    {
                        id: "f6e0b4f7-77c8-4b14-9454-f20d797b727d",
                        title: "Sed viverra tellus in hac habitasse platea dictumst vestibulum.",
                        content:
                            "Maecenas volutpat blandit aliquam etiam. Diam volutpat commodo sed egestas egestas fringilla phasellus faucibus scelerisque. Est ullamcorper eget nulla facilisi etiam dignissim diam quis. Tincidunt praesent semper feugiat nibh sed pulvinar proin gravida hendrerit. Varius vel pharetra vel turpis nunc eget. Enim ut tellus elementum sagittis vitae et leo duis.",
                    },
                    {
                        id: "82838c69-f2a6-47cd-b6df-dee1909d2019",
                        title: "Porttitor leo a diam sollicitudin tempor id eu nisl.",
                        content:
                            "Ut diam quam nulla porttitor massa id neque. Nulla facilisi etiam dignissim diam quis enim lobortis. Quam nulla porttitor massa id. Neque ornare aenean euismod elementum nisi quis eleifend quam adipiscing. Justo nec ultrices dui sapien eget mi. Volutpat diam ut venenatis tellus in. Mi in nulla posuere sollicitudin aliquam ultrices.",
                    },
                    {
                        id: "1a65f23a-485a-4646-a65d-cab6fd1e4603",
                        title: "Leo vel orci porta non pulvinar neque laoreet.",
                        content:
                            "Placerat duis ultricies lacus sed. Pellentesque adipiscing commodo elit at imperdiet dui. Accumsan lacus vel facilisis volutpat. Condimentum lacinia quis vel eros donec ac. Pellentesque habitant morbi tristique senectus. Ultrices eros in cursus turpis massa tincidunt dui ut ornare. Rhoncus urna neque viverra justo nec ultrices dui sapien. Amet venenatis urna cursus eget.",
                    },
                ],
            },
            {
                id: "5acb5684-4b99-44ff-9668-2e5daec9133c",
                class: "columns-3-balanced",
                header: "Global",
                type: "articles-list",
                content: [
                    {
                        id: "a96310f4-89cb-4ea7-a10a-9e03ebbd013e",
                        title: "Platea dictumst quisque sagittis purus sit amet volutpat consequat mauris.",
                        content:
                            "Eu lobortis elementum nibh tellus molestie nunc. Vel turpis nunc eget lorem dolor sed viverra. Massa sapien faucibus et molestie ac feugiat sed. Sed egestas egestas fringilla phasellus faucibus. At erat pellentesque adipiscing commodo elit at imperdiet dui accumsan",
                    },
                    {
                        id: "870d65da-27ab-45f8-9b03-4d5c71e1b31e",
                        title: "Ultrices gravida dictum fusce ut placerat orci nulla pellentesque.",
                        content:
                            "Velit ut tortor pretium viverra suspendisse potenti nullam ac tortor. Feugiat nibh sed pulvinar proin gravida. Feugiat in fermentum posuere urna nec tincidunt praesent. Nulla posuere sollicitudin aliquam ultrices sagittis orci a scelerisque. A scelerisque purus semper eget.",
                    },
                    {
                        id: "e6bc4824-319b-4f0e-a3ef-408cc24219eb",
                        title: "Est ullamcorper eget nulla facilisi etiam.",
                        content:
                            "Augue mauris augue neque gravida in fermentum et. Ornare arcu odio ut sem nulla pharetra diam. Tristique et egestas quis ipsum suspendisse ultrices gravida. Aliquam vestibulum morbi blandit cursus risus at ultrices mi. Non blandit massa enim nec dui nunc mattis.",
                    },
                ],
            },
            {
                id: "fd9fce73-e286-450f-8fcf-7b988b968f3b",
                class: "columns-3-balanced",
                header: "Quarterly",
                type: "articles-list",
                content: [
                    {
                        id: "90fc8d03-c410-46f6-ad57-d90f25e199e3",
                        title: "Non curabitur gravida arcu ac tortor dignissim.",
                        content:
                            "Dui nunc mattis enim ut. Non consectetur a erat nam. Arcu vitae elementum curabitur vitae nunc sed velit dignissim. Congue quisque egestas diam in arcu cursus euismod quis viverra. Consequat semper viverra nam libero justo laoreet sit amet.",
                    },
                    {
                        id: "88c3b366-32e0-4e8b-9735-5dc2194b5e42",
                        title: "Velit egestas dui id ornare arcu odio ut.",
                        content:
                            "At ultrices mi tempus imperdiet nulla malesuada pellentesque elit eget. Aenean et tortor at risus viverra. Lectus magna fringilla urna porttitor rhoncus dolor. Posuere lorem ipsum dolor sit amet consectetur adipiscing elit. Euismod in pellentesque massa placerat duis ultricies lacus sed turpis.",
                    },
                    {
                        id: "fb087f5c-84d0-4a1a-a9f6-96af0914527d",
                        title: "Malesuada nunc vel risus commodo viverra maecenas accumsan lacus vel.",
                        content:
                            "Nunc eget lorem dolor sed. Amet aliquam id diam maecenas ultricies mi. Sodales ut etiam sit amet nisl purus. Consectetur adipiscing elit ut aliquam purus sit amet luctus venenatis. Fusce ut placerat orci nulla pellentesque dignissim enim sit.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-underscored",
        name: "Underscored",
        articles: [
            {
                id: "f7640582-e9b6-4d47-b396-95515aa0a840",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "2f3a3748-60b2-45b3-b697-2cb4e0a6414d",
                        image: {
                            src: "assets/images/dillon-kydd-2keCPb73aQY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Netus et malesuada fames ac turpis egestas. Habitasse platea dictumst vestibulum rhoncus est pellentesque elit ullamcorper dignissim. Morbi tempus iaculis urna id volutpat lacus laoreet non curabitur. Sed enim ut sem viverra. Tellus integer feugiat scelerisque varius morbi enim.",
                        url: "#",
                    },
                    {
                        id: "fc5ca351-9505-4cf7-82cc-b176bf9421d3",
                        image: {
                            src: "assets/images/aaron-huber-G7sE2S4Lab4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Aenean vel elit scelerisque mauris. Et ligula ullamcorper malesuada proin libero nunc. Mi sit amet mauris commodo quis imperdiet. Elit ullamcorper dignissim cras tincidunt lobortis feugiat. Erat velit scelerisque in dictum non consectetur a erat nam. Orci porta non pulvinar neque.",
                        url: "#",
                    },
                ],
            },
            {
                id: "3f4c33ce-8628-46d1-b416-37b0fc218c74",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "f7961c4a-df0b-4d2e-b699-edce14aef7a2",
                        image: {
                            src: "assets/images/mesut-kaya-eOcyhe5-9sQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Eget gravida cum sociis natoque penatibus et. Malesuada pellentesque elit eget gravida cum. Curabitur vitae nunc sed velit dignissim sodales ut. Curabitur vitae nunc sed velit dignissim. Vel pretium lectus quam id leo in. Aliquet lectus proin nibh nisl condimentum id venenatis a.",
                        url: "#",
                    },
                    {
                        id: "09287d46-2d4c-4043-a878-086b705da83e",
                        image: {
                            src: "assets/images/diego-jimenez-A-NVHPka9Rk-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Tristique senectus et netus et malesuada fames ac turpis. Semper risus in hendrerit gravida rutrum. Urna cursus eget nunc scelerisque viverra. Amet mauris commodo quis imperdiet massa. Erat nam at lectus urna duis convallis convallis tellus id.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-state-by-state",
        name: "State by state",
        articles: [
            {
                id: "88c59d52-03e2-47cc-82a0-f0d9df4a88db",
                class: "columns-wrap",
                header: "California",
                type: "excerpt",
                content: [
                    {
                        id: "1f94b398-03e0-46c4-b3db-f89f1076fb8c",
                        image: {
                            src: "assets/images/craig-melville-_JKymnZ1Uc4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Et tortor at risus viverra adipiscing at. Leo urna molestie at elementum eu facilisis sed. Adipiscing tristique risus nec feugiat in fermentum posuere urna.",
                    },
                    {
                        id: "6e02b59a-38fb-40f8-9b95-aa0c9eb0bdf4",
                        image: {
                            src: "assets/images/robert-bye-EILw-nEK46k-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Luctus venenatis lectus magna fringilla. Condimentum mattis pellentesque id nibh tortor id. Rhoncus aenean vel elit scelerisque mauris pellentesque.",
                    },
                    {
                        id: "10c89ad8-d9be-4d73-9002-122e504f317c",
                        image: {
                            src: "assets/images/sapan-patel-gmgWd0CgWQI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Feugiat scelerisque varius morbi enim nunc. Amet consectetur adipiscing elit ut aliquam purus sit amet luctus. Orci a scelerisque purus semper eget duis at tellus at.",
                    },
                ],
            },
            {
                id: "f28c0060-72db-4588-8b38-9f1b2a01a3ac",
                class: "columns-wrap",
                header: "New York",
                type: "excerpt",
                content: [
                    {
                        id: "11a4ac22-47c5-4a55-acc0-fd8ca15a84d8",
                        image: {
                            src: "assets/images/prince-abban-0OUHhvNIbYc-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Vitae sapien pellentesque habitant morbi tristique. Quisque id diam vel quam elementum pulvinar etiam non. Hendrerit gravida rutrum quisque non tellus orci.",
                    },
                    {
                        id: "77850587-f7e1-4b3c-83c2-f1e705a4eed0",
                        image: {
                            src: "assets/images/quick-ps-sW41y3lETZk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Rhoncus dolor purus non enim praesent. Massa enim nec dui nunc mattis. Odio eu feugiat pretium nibh ipsum consequat. Bibendum enim facilisis gravida neque convallis a cras.",
                    },
                    {
                        id: "f407272d-1e0e-4782-9031-aa90f33a5604",
                        image: {
                            src: "assets/images/lorenzo-moschi-N7ypjB7HKIk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Cursus euismod quis viverra nibh. Facilisis mauris sit amet massa. Eget mauris pharetra et ultrices. Vitae turpis massa sed elementum tempus egestas sed. Semper viverra nam libero justo.",
                    },
                ],
            },
            {
                id: "bc567ef4-d017-4679-8d7b-c822dd49a3dc",
                class: "columns-wrap",
                header: "Washington",
                type: "excerpt",
                content: [
                    {
                        id: "86afb098-dd8b-453b-9e90-68275a4457fc",
                        image: {
                            src: "assets/images/koshu-kunii-v9ferChkC9A-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Iaculis nunc sed augue lacus viverra. Sed libero enim sed faucibus turpis in. Massa tincidunt dui ut ornare. Adipiscing bibendum est ultricies integer quis auctor elit.",
                    },
                    {
                        id: "f653d697-a6ce-4e98-b76e-fa9b84bf5546",
                        image: {
                            src: "assets/images/angela-loria-hFc0JEKD4Cc-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Aliquet nec ullamcorper sit amet risus nullam eget felis eget. Tortor dignissim convallis aenean et tortor at risus. Dolor sed viverra ipsum nunc.",
                    },
                    {
                        id: "05e813bd-c4ab-4c30-9922-d90b6d3925a4",
                        image: {
                            src: "assets/images/harold-mendoza-6xafY_AE1LM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "In cursus turpis massa tincidunt dui ut ornare. Lacus vestibulum sed arcu non odio euismod lacinia at. Mi ipsum faucibus vitae aliquet nec. Commodo sed egestas egestas fringilla phasellus faucibus scelerisque eleifend.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "4a2d747f-a853-4452-82bf-504b5f79a7fe",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "5763aa2d-06a9-4c17-bd6f-c8b9ebb99f18",
                        image: {
                            src: "assets/images/libre-leung-9O0Sp22DF0I-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Magna ac placerat vestibulum lectus mauris ultrices eros. Risus nullam eget felis eget nunc. Orci porta non pulvinar neque. Aliquam purus sit amet luctus venenatis lectus magna fringilla urna. In arcu cursus euismod quis viverra nibh.",
                        url: "#",
                    },
                    {
                        id: "71d069ec-a854-41ba-8e68-7d236a2f7810",
                        image: {
                            src: "assets/images/pascal-bullan-M8sQPAfhPdk-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Id venenatis a condimentum vitae sapien. Dui vivamus arcu felis bibendum ut tristique. Laoreet sit amet cursus sit amet dictum sit amet justo. Id semper risus in hendrerit gravida rutrum quisque non. Posuere sollicitudin aliquam ultrices sagittis orci a scelerisque.",
                        url: "#",
                    },
                ],
            },
            {
                id: "c897ed90-26b7-4f9d-9c2c-7eb37270a317",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "e1509eb7-5e49-40fb-8581-4cd2d07a697d",
                        image: {
                            src: "assets/images/brooke-lark-HjWzkqW1dgI-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Nulla porttitor massa id neque aliquam. Amet massa vitae tortor condimentum lacinia quis vel. Semper quis lectus nulla at volutpat diam ut venenatis. In nulla posuere sollicitudin aliquam ultrices.",
                        url: "#",
                    },
                    {
                        id: "8107bf22-c893-44e3-a359-2c5d1dcd96f7",
                        image: {
                            src: "assets/images/matthias-heil-lDOEwat_MPs-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Egestas congue quisque egestas diam in arcu cursus. Vitae tempus quam pellentesque nec nam aliquam. Proin nibh nisl condimentum id. Mattis ullamcorper velit sed ullamcorper morbi tincidunt. Egestas integer eget aliquet nibh praesent tristique.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-us-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "3acc4e4e-2720-4d9a-aa3e-ec820f6b4f00",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "01e18bfc-4a30-4c5c-bdc1-c7dd8f89a550",
                        image: {
                            src: "assets/images/tadeusz-lakota-Tb38UzCvKCY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Mi tempus imperdiet nulla malesuada pellentesque elit eget gravida cum. Nec tincidunt praesent semper feugiat nibh sed pulvinar proin.",
                    },
                ],
            },
            {
                id: "ca777be8-b675-4dc0-817f-972a72129394",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "2ece17ee-a3fc-4400-96e1-4a7571f1a77f",
                        image: {
                            src: "assets/images/leisara-studio-EzzW1oNek-I-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Sed cras ornare arcu dui vivamus arcu. Blandit aliquam etiam erat velit scelerisque in. Nisl rhoncus mattis rhoncus urna neque viverra.",
                    },
                ],
            },
            {
                id: "cb0c2767-4955-4cc6-ae13-5c44a958b36f",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "3677b20d-aba5-44b4-b0f7-a286d138305e",
                        image: {
                            src: "assets/images/tamanna-rumee-lpGm415q9JA-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nunc sed id semper risus in hendrerit gravida rutrum. Ac felis donec et odio pellentesque diam volutpat commodo sed.",
                    },
                ],
            },
            {
                id: "efe39446-2154-4279-9d1d-66d27db034ac",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "5f1ef3f2-81ea-48e2-8efa-648cc85b4f3d",
                        image: {
                            src: "assets/images/clark-street-mercantile-P3pI6xzovu0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Semper quis lectus nulla at volutpat diam ut venenatis tellus. Felis eget nunc lobortis mattis aliquam faucibus purus in massa. Et malesuada fames ac turpis.",
                    },
                ],
            },
        ],
    },
];
